import { Box } from '@mui/material';

const Footer: React.FC = () => {
    return (
        <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            width: '100%',
            backgroundColor: 'var(--buttonBackColor)',
            color: 'var(--buttonTextColor)',

        }} >
            <Box
                sx={{
                    zIndex: '1',
                    width: '100vw',
                    height: '100px',
                    backgroundColor: 'var(--buttonBackColor)',
                    padding: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    flexDirection: "column",
                    fontSize: { xs: '0.8rem', md: '1rem' }
                }}
                gap={1}
            >
                <span>
                    Copyright © {new Date().getUTCFullYear()} Majid Ghajari. All rights reserved
                </span>

                <a
                    style={{ color: 'var(--buttonTextColor)', textDecoration: 'none', }}
                    href="http://www.majidg.com"
                    target="_blank"
                    rel="noopener noreferrer">
                    www.majidg.com
                </a>
                <a
                    style={{ color: 'var(--buttonTextColor)', textDecoration: 'none', }}
                    href="mailto:majidgdotcom@gmail.com">
                    majidgdotcom@gmail.com
                </a>
            </Box>
        </Box>
    );
};

export default Footer;